export default {"src":"/_next/static/media/500.304d93e8.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};